import React, { Component } from 'react';

class Roll extends Component {
    render() {
        return (
            <div className='roll'>
              <button className='btn btn__fill'> 
                  ROLL LO
              </button>
              <button className='btn btn__fill'>
                 ROLL HI
              </button>
            </div>
        )
    }
}

export default Roll;


// WEBPACK FOOTER //
// ./src/components/bet/Roll.js